import { shallow } from "zustand/shallow";
/// This function allows you to specify which store keys a component relies on,
/// so that it doesn't re-render when un-used keys change
export const createStoreWithSelectors = (store) => {
    const useStore = (keys) => {
        return store((state) => {
            const x = keys.reduce((acc, cur) => {
                acc[cur] = state[cur];
                return acc;
            }, {});
            return x;
        }, shallow);
    };
    return useStore;
};
